import UserFundraisersList from "@components/UserFundraisersList";
import { NoMoreFeedItemsCallbackProp } from "@components/feed";
import { PageSection } from "@components/layout/PageSection";

import { UserResponse } from "@every.org/common/src/codecs/entities";

interface FundraisersTabProps extends NoMoreFeedItemsCallbackProp {
  user: UserResponse;
}

export const FundraisersTab = ({ user }: FundraisersTabProps) => {
  if (!user) {
    return null;
  }

  return (
    <PageSection>
      <UserFundraisersList user={user} />
    </PageSection>
  );
};
